import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import { fetchAppicazione, fetchSiccurezza, fetchTrattamenti, fetchTrattamento } from "../../../features/trattamenti/trattamentiThunk";
import tableData from "../../../utils/strucuture/SubTrattamentiData.json";
import { selectError, selectIsLoading } from "../../../features/trattamenti/trattamentiSlice";
import { useEffect } from "react";
import { fetchCompanies } from "../../../features/company/companyThunk";

const SubTrattamenti = () => {
    const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
    const columns = [
        { field: "tipo_di_trattamento", headerName: "Tipo di trattamento", width: 200 },
        { field: "terreno_id", headerName: "ID terreno", width: 150 },
        { field: "particella_id", headerName: "ID Parcella", width: 150 },
        { field: "data_trattamento", headerName: "Data", width: 150 },
        { field: "prodotto_utilizzato", headerName: "Prodotto utilizzato", width: 200 },
        { field: "qty", headerName: "Q.ta prodotto", width: 150 },
        { field: "applicazione", headerName: "Mod. applicazione", width: 200 },
        { field: "operatore_id", headerName: "Operatore Resp.", width: 200 },
        { field: "intervallo_sicurezza", headerName: "Int. sicurezza (GG)", width: 200 },
        { field: "azioni", headerName: "Azioni", width: 100, sortable: false }
    ];

    const dispatch = useDispatch();

    const trattamentiData = useSelector((store) => store.trattamenti.trattamenti);
    const isLoading = useSelector(selectIsLoading);
    const error = useSelector(selectError);
    const data = trattamentiData
    ?.filter(op => op.role_id === "OPERATOR")
    useEffect(() => {
        dispatch(fetchCompanies())
    },[])

    useEffect(() => {

        dispatch(fetchTrattamenti());

        dispatch(fetchTrattamento())
        dispatch(fetchSiccurezza())
        dispatch(fetchAppicazione())
    }, [dispatch, selectSelectedCompany]);
    console.log(trattamentiData, "trattamentiData",)


    return (
        <>
            <div className="pageTemplate">
                <Table data={trattamentiData} columns={columns} navData={"subTrattamenti"} deleteFunctions={"deleteTrattamentiByID"} />
            </div>
        </>
    );
};

export default SubTrattamenti;
